import "./ArchitectureCodeSample.css";
import { useState, useEffect } from "react";

import codeArchitectureIcon from "../../../../Assets/Icons/code-architecture-icon.svg";
import architectureSample1 from "../../../../Assets/Images/Arch1.png";
import architectureSample2 from "../../../../Assets/Images/Arch2.png";

const ArchitectureCodeSample = () => {
  const architectureImages = [architectureSample1, architectureSample2];

  return (
    <section id="samples" className="architecture-code-sample">
      <div className="architecture-code-sample__container">
        <div className="architecture-code-sample__content">
          <div className="architecture-code-sample__icon-wrapper">
            <div className="architecture-code-sample__icon">
              <img src={codeArchitectureIcon} alt="code architecture icon" />
            </div>
          </div>
          <h2 className="architecture-code-sample__title">
             Look Inside The Architecture We Build
          </h2>
        </div>

        <div className="architecture-code-sample__diagram-wrapper">
          <ArchitectureDiagramSlider images={architectureImages} />
        </div>
      </div>
    </section>
  );
};

// Component to handle the sliding functionality
const ArchitectureDiagramSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalImages = images.length;

  useEffect(() => {
    if (totalImages <= 1) return;

    // Adjust interval based on screen size (slower on mobile)
    const getInterval = () => (window.innerWidth <= 768 ? 5000 : 3000);
    let interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalImages);
    }, getInterval());

    // Optional: re-evaluate interval on resize (basic approach)
    const handleResize = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % totalImages);
      }, getInterval());
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, [totalImages]);

  return (
    <>
      <div className="architecture-code-sample__image-container">
        <img
          src={images[currentIndex]}
          alt={`Architecture Sample ${currentIndex + 1}`}
          className="architecture-code-sample__image"
        />
      </div>

      {totalImages > 1 && (
        <div className="architecture-code-sample__progress-indicator">
          {images.map((_, index) => (
            <div
              key={index}
              className={`architecture-code-sample__progress-bar ${
                currentIndex === index
                  ? "architecture-code-sample__progress-bar--active"
                  : ""
              }`}
            ></div>
          ))}
        </div>
      )}
    </>
  );
};

export default ArchitectureCodeSample;
